import { useState } from "react";

export default function RPGButton() {
  return (
    <div>
      <button
        name="game_button"
        className="text-white bg-black bg-opacity-0 h-10 px-5 rounded-lg border border-white transition duration-300 ease-in-out hover:bg-white hover:text-black hover:border-transparent hover:shadow-outline"
      >
        <a
          href="https://rpg.polarfi.site/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Play Now
        </a>
      </button>
    </div>
  );
}
